import { add, init } from '@amplitude/analytics-browser';
import { plugin as engagementPlugin } from '@amplitude/engagement-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

import { getStaticPathAndSearch } from 'navigation/location/location';
import { extractQueryParams } from 'navigation/utils';
import { initGTM, sendGoogleTagManagerEvent } from 'utils/google-tag-manager';

import { setUTMParams } from '.';

export {
  getSessionId,
  getDeviceId,
  identify,
  Identify,
  revenue,
  Revenue,
  setDeviceId,
  setOptOut,
  setSessionId,
  setUserId,
  track,
  Types,
} from '@amplitude/analytics-browser';

export const initAmplitudeWithPluginsForPlatform = async (
  amplitudeKey: string,
  cognitoId: string,
  options: any
) => {
  await add({
    name: 'google-tag-manager',
    type: 'destination',
    setup: initGTM,
    execute: sendGoogleTagManagerEvent,
  }).promise;

  await add(
    sessionReplayPlugin({
      // remote configuration seems to be implicitly enabled by default unlike react native's config
      sampleRate: 0.2,
    })
  ).promise;

  await init(amplitudeKey, cognitoId, options).promise;

  await add(engagementPlugin()).promise;

  // Set UTM parameters for web
  // The UTM parameters in mobile are handled by
  // the native intent + branch deep linking
  // Web does not have a native intent + branch deep linking,
  // so we need to set the UTM parameters here
  const uri = getStaticPathAndSearch();
  const utmParams = extractQueryParams(uri);
  setUTMParams(utmParams);
};
